/**
 * DevExtreme (esm/ui/popover/ui.popover.full.js)
 * Version: 22.2.13
 * Build date: Fri Aug 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import "../toolbar";
import Popover from "../popover/ui.popover";
import registerComponent from "../../core/component_registrator";
export default class PopoverFull extends Popover {
    _getToolbarName() {
        return "dxToolbar"
    }
}
PopoverFull.defaultOptions = function(rule) {
    Popover.defaultOptions(rule)
};
registerComponent("dxPopover", PopoverFull);
